module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre8",
    attrs: {
      "id": "pgepubid00018"
    }
  }, [_c('a', {
    staticClass: "pcalibre pcalibre1 calibre16 pcalibre2",
    attrs: {
      "id": "The_Lion_and_the_Crane"
    }
  }), _vm._v("The Lion and the Crane")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("The Bodhisatta was at one time born in the region of Himavanta as a white crane; now Brahmadatta was at that time reigning in Benares. Now it chanced that as a lion was eating meat a bone stuck in his throat. The throat became swollen, he could not take food, his suffering was terrible. The crane seeing him, as he was perched on a tree looking for food, asked, \"What ails thee, friend?\" He told him why. \"I could free thee from that bone, friend, but dare not enter thy mouth for fear thou mightest eat me.\" \"Don't be afraid, friend, I'll not eat thee; only save my life.\" \"Very well,\" says he, and caused him to lie down on his left side. But thinking to himself, \"Who knows what this fellow will do,\" he placed a small stick upright between his two jaws that he could not close his mouth, and inserting his head inside his mouth struck one end of the bone with his beak. Whereupon the bone dropped and fell out. As soon as he had caused the bone to fall, he got out of the lion's mouth, striking the stick with his beak so that it fell out, and then"), _c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "id": "Page_2",
      "title": "[2]"
    }
  }), _vm._v(" settled on a branch. The lion gets well, and one day was eating a buffalo he had killed. The crane thinking \"I will sound him,\" settled on a branch just over him, and in conversation spoke this first verse:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("\"A service have we done thee"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("To the best of our ability,"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("King of the Beasts! Your Majesty!"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("What return shall we get from thee?\""), _c('br', {
    staticClass: "calibre17"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("In reply the Lion spoke the second verse:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("\"As I feed on blood,"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("And always hunt for prey,"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("'Tis much that thou art still alive"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("Having once been between my teeth.\""), _c('br', {
    staticClass: "calibre17"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("Then in reply the crane said the two other verses:")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("\"Ungrateful, doing no good,"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("Not doing as he would be done by,"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("In him there is no gratitude,"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("To serve him is useless."), _c('br', {
    staticClass: "calibre17"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("\"His friendship is not won"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("By the clearest good deed."), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Better softly withdraw from him,"), _c('br', {
    staticClass: "calibre17"
  })]), _vm._v(" "), _c('span', {
    staticClass: "i1"
  }, [_vm._v("Neither envying nor abusing.\""), _c('br', {
    staticClass: "calibre17"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_vm._v("And having thus spoken the crane flew away.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('i', {
    staticClass: "calibre12"
  }, [_vm._v("And when the great Teacher, Gautama the Buddha, told this tale, he used to add: \"Now at that time the lion was Devadatta the Traitor, but the white crane was I myself.\"")])]), _vm._v(" "), _c('div', {
    staticClass: "figcenter"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "id": "image_02"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "calibre7",
    attrs: {
      "alt": "THE LION AND THE CRANE",
      "src": "Images/img0039.jpg",
      "title": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caption"
  }, [_vm._v("THE LION AND THE CRANE")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('a', {
    staticClass: "pcalibre pcalibre2 pcalibre1",
    attrs: {
      "id": "Page_3",
      "title": "[3]"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0